// Ref: https://www.letsbuildui.dev/articles/building-a-segmented-control-component/
import { useRef, useState, useEffect } from "react";
import "./SegmentedControl.css";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-segmented-control-component
 */
const SegmentedControl = ({
  className,
  name,
  segments,
  callback,
  defaultIndex = 0,
  controlRef,
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const componentReady = useRef();

  // Determine when the component is "ready"
  useEffect(() => {
    componentReady.current = true;
  }, []);

  useEffect(() => {
    const activeSegmentRef = segments[activeIndex].ref;
    const { offsetWidth, offsetLeft } = activeSegmentRef.current;
    const { style } = controlRef.current;

    style.setProperty("--highlight-width", `${offsetWidth}px`);
    style.setProperty("--highlight-x-pos", `${offsetLeft}px`);
  }, [activeIndex, callback, controlRef, segments]);

  useEffect(() => {
    setActiveIndex(defaultIndex);
  }, [defaultIndex]);

  const onInputChange = (value, index) => {
    setActiveIndex(index);
    callback(value, index);
  };

  return (
    <div className={`controls-container flex ${className}`} ref={controlRef}>
      <div
        className={`w-full controls ${
          componentReady.current ? "ready" : "idle"
        }`}
      >
        {segments?.map((item, i) => (
          <div
            key={item.value}
            className={`w-1/2 segment ${
              i === activeIndex ? "active" : "inactive"
            }`}
            ref={item.ref}
          >
            <input
              type="radio"
              value={item.value}
              id={item.label}
              name={name}
              onChange={() => onInputChange(item.value, i)}
              checked={i === activeIndex}
            />
            <label htmlFor={item.label}>{item.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SegmentedControl;
